<template>
  <div id="contenedor-contrato-editar-frente">
    <v-form
      v-model="formularioValido"
      ref="editarContratoFrente">
      <v-card>
        <v-card-title>
          Registrar nuevo frente
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12">
              <custom-text-field
                v-model="frente.descripcion"
                label="Descricpión"
                :rules="[mixReglas.requerido]">
              </custom-text-field>
            </v-col>
            <v-col
              cols="12">
              <custom-text-field
                v-model.number="frente.orden"
                type="number"
                label="Orden"
                :rules="[mixReglas.requerido]">
              </custom-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarFrente"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixContratoFrentes from './mixContratoFrentes';

export default {
  name: 'ContratoEditarFrente',
  mixins: [mixContratoFrentes],
  components: {
    CustomTextField,
    CustomButton,
  },
  props: {
    frenteEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      frente: {
        descripcion: this.frenteEditar.descripcion,
        orden: this.frenteEditar.orden,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarContratoFrente.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
